import React, { useEffect, useState } from "react";

//MUI
import {
  Card,
  Chip,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

//Icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
//Third Party Imports
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import useAxiosAuth from "../../../../hooks/useAxiosAuth";

import JobPost from "../../../../components/job-post/JobPost";

// import EmployerSpecialization from "../employer-specializations";
import EmployerPayment from "../employer-payments";

const EmployerDetails = () => {
  //Constants
  const theme = useTheme();
  const axiosAuth = useAxiosAuth();
  const navigate = useNavigate();

  //States
  const [employerDetails, setEmployerDetails] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  //Services
  const getEmployerDetails = () => {
    if (searchParams.get("ref") === null) {
      return;
    }
    let id = searchParams.get("ref");
    axiosAuth
      .get("/api/Employers/" + id)
      .then((response) => {
        setEmployerDetails(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //UseEffects
  useEffect(() => {
    getEmployerDetails();
  }, []);

  return (
    <div>
      <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
        <Card elevation={3}>
          <Grid
            sx={{
              background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
              paddingX: 2,
              paddingY: 1,
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={12} sm={10} md={10} lg={10}>
                <Typography variant="h5" color="white.main">
                  Employer Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                  <Tooltip title="Back">
                    <IconButton color="inherit" onClick={() => navigate(-1)}>
                      <ArrowBackIcon sx={{ color: "#ffffff" }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Edit Employer">
                    <IconButton
                      color="inherit"
                      onClick={() =>
                        navigate(
                          "/admin/employers/form?Id=" + searchParams.get("ref")
                        )
                      }
                    >
                      <EditIcon sx={{ color: "#ffffff" }} />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid item sm={12} xs={12}>
              {/* <Card
                variant="outlined"
                sx={{
                  minHeight: "150px",
                  padding: 2,
                  display: "flex",
                  direction: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // backgroundColor: theme.palette.primary.light,
                  // cursor: "pointer",
                  // "&:hover": {
                  //   boxShadow:
                  //     "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                  // },
                }}
              > */}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    color={theme.palette.primary.dark}
                    variant="h5"
                    textAlign="left"
                  >
                    {employerDetails.name}
                  </Typography>
                  <Typography variant="body1">
                    {employerDetails.city}
                  </Typography>
                </Grid>

                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Name:
                  </Typography>
                  <Typography variant="body2">
                    {employerDetails.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Address:
                  </Typography>
                  <Typography align="left" variant="subtitle1">
                    {employerDetails.addressLine1},{" "}
                    {employerDetails.addressLine2}, {employerDetails.city}{" "}
                    {employerDetails.pinCode}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Email:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.email ? employerDetails.email : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Mobile No.:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.phoneNumber
                      ? employerDetails.phoneNumber
                      : "--"}
                  </Typography>
                </Grid>

                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Taluka:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.taluka ? employerDetails.taluka : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    District:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.district ? employerDetails.district : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    State:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.state ? employerDetails.state : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Website:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.website ? employerDetails.website : "--"}
                  </Typography>
                </Grid>
                {/* <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Registration Status:
                  </Typography>
                  <Chip
                    label={employerDetails.registrationStatusDisplay}
                    color={
                      employerDetails.registrationStatus === 1
                        ? "success"
                        : "warning"
                    }
                    variant="contained"
                  />
                </Grid> */}
                <Grid item xs={12}>
                  {" "}
                  <Typography
                    color={theme.palette.primary.dark}
                    variant="h6"
                    textAlign="left"
                  >
                    Contact Details
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Contact Person 1:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson1Name
                      ? employerDetails.contactPerson1Name
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Mobile No.:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson1PhoneNumber
                      ? employerDetails.contactPerson1PhoneNumber
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Email:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson1Email
                      ? employerDetails.contactPerson1Email
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Constact Person 2:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson2Name
                      ? employerDetails.contactPerson2Name
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Mobile No:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson2PhoneNumber
                      ? employerDetails.contactPerson2PhoneNumber
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Email:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson2Email
                      ? employerDetails.contactPerson2Email
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Contact Person 3:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson3Name
                      ? employerDetails.contactPerson3Name
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Mobile No.:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson3PhoneNumber
                      ? employerDetails.contactPerson3PhoneNumber
                      : "--"}
                  </Typography>
                </Grid>
                <Grid item lg={4} xl={4} md={6} sm={6} xs={12}>
                  <Typography
                    color={theme.palette.grey[600]}
                    variant="subtitle2"
                  >
                    Email:
                  </Typography>
                  <Typography variant="subtitle1">
                    {employerDetails.contactPerson3Email
                      ? employerDetails.contactPerson3Email
                      : "--"}
                  </Typography>
                </Grid>
              </Grid>
              {/* </Card> */}
              {/* <Grid item sm={12} xs={12}>
                  <Box key={row.id}  sx={{ marginBottom: 2 }}>
                  <JobPost jobPost={row} type={2} />
                </Box>
                  </Grid> */}
            </Grid>
            {/* <Grid item sm={12} xs={12}>
              <EmployerSpecialization employerId={employerDetails.id} />
            </Grid>*/}
            {/* <Grid item sm={12} xs={12}>
              <EmployerPayment employerId={employerDetails?.id} />
            </Grid> */}
          </Grid>
        </Card>
      </Grid>
    </div>
  );
};

export default EmployerDetails;
